import { profile } from "../data";
import { Ornament, Reveal, Section } from "./ui";

export function Contact() {
  return (
    <Section id="contact" title="Get in touch" intro="If there's a team I could learn from, I'd like to hear about it.">
      <Reveal>
        <div className="glass halo leaf relative overflow-hidden p-8 sm:p-12">
          <div
            aria-hidden="true"
            className="drift pointer-events-none absolute -top-24 -right-16 h-64 w-64 rounded-full opacity-60 blur-3xl"
            style={{
              background:
                "radial-gradient(circle at 40% 40%, rgba(235,166,198,0.55), rgba(190,167,242,0.25) 55%, transparent 75%)",
            }}
          />

          <div className="relative">
            <p className="text-display-italic max-w-[30ch] text-[1.6rem] leading-snug text-porcelain sm:text-[2.1rem]">
              Tell me what you're building, and I'll tell you how I can help.
            </p>

            <a
              href={`mailto:${profile.email}`}
              className="text-display mist-gradient mt-8 inline-block text-[clamp(1.3rem,4vw,2.1rem)] leading-tight"
            >
              {profile.email}
            </a>

            <div className="mt-10">
              <Ornament />
            </div>

            <dl className="mt-10 grid gap-8 sm:grid-cols-3">
              <div>
                <dt className="text-[0.78rem] text-faint">Phone</dt>
                <dd className="mt-1.5">
                  <a
                    href={`tel:${profile.phone.replace(/\s/g, "")}`}
                    className="link-underline text-[0.95rem] text-porcelain/90 transition-colors hover:text-porcelain"
                  >
                    {profile.phone}
                  </a>
                </dd>
              </div>
              <div>
                <dt className="text-[0.78rem] text-faint">LinkedIn</dt>
                <dd className="mt-1.5">
                  <a
                    href={profile.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className="link-underline text-[0.95rem] text-porcelain/90 transition-colors hover:text-porcelain"
                  >
                    {profile.linkedinLabel}
                  </a>
                </dd>
              </div>
              <div>
                <dt className="text-[0.78rem] text-faint">Elsewhere</dt>
                <dd className="mt-1.5">
                  <a
                    href={profile.resume}
                    className="link-underline text-[0.95rem] text-porcelain/90 transition-colors hover:text-porcelain"
                  >
                    Download résumé
                  </a>
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </Reveal>
    </Section>
  );
}
